<adapt-objectives-page-navigator buttonText="Record annual objectives"
                                 [pageActivationTours]="PageActivationTours"></adapt-objectives-page-navigator>
